// Filtro de palavras ofensivas do nome de sala, do nome de trio e do apelido. Compara sem acento, sem maiúscula, com
// letras repetidas colapsadas e com os números e símbolos que imitam letras (p0rr4, $exo). O servidor valida; a tela
// avisa antes.
import { NOME_DE_SALA_MAX } from '@truco6/planos';
import { FLEXOES, PALAVRAS, RAIZES, TERMINACOES, TRECHOS } from './palavras.ts';

const IMITACOES: Record<string, string> = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', '$': 's' };

// Minúsculas, sem acento, imitações trocadas, só letras e espaços, letras repetidas colapsadas ("poooorra" vira "pora").
export function normalizar(texto: string): string {
  return texto
    .toLowerCase()
    .normalize('NFD').replace(/\p{M}/gu, '')
    .replace(/[013457@$]/g, (c) => IMITACOES[c]!)
    .replace(/[^a-z]+/g, ' ')
    .replace(/([a-z])\1+/g, '$1')
    .trim();
}

const TRECHOS_N = TRECHOS.map(normalizar);
const PALAVRAS_N = new Set(PALAVRAS.map(normalizar));
const FLEXIONADAS_N = new Set(RAIZES.flatMap((r) => FLEXOES.map((f) => normalizar(r + f))));

function palavraOfensiva(p: string): boolean {
  return FLEXIONADAS_N.has(p) || TERMINACOES.some((t) => p.endsWith(t) && PALAVRAS_N.has(p.slice(0, p.length - t.length)));
}

export function ofensivo(texto: string): boolean {
  const n = normalizar(texto);
  if (!n) return false;
  // Letras soltas viram uma palavra só: "p u t a" é "puta".
  const palavras = n.replace(/\b([a-z])\b(?: \b([a-z])\b)+/g, (m) => m.replace(/ /g, '')).split(' ');
  if (palavras.some(palavraOfensiva)) return true;
  const colado = n.replace(/ /g, '');
  return TRECHOS_N.some((t) => colado.includes(t));
}

export type ResultadoNome = 'ok' | 'longo' | 'ofensivo';

export function validarNomeDeSala(nome: string): ResultadoNome {
  if ([...nome.trim()].length > NOME_DE_SALA_MAX) return 'longo';
  return ofensivo(nome) ? 'ofensivo' : 'ok';
}

export const MENSAGEM_NOME: Record<Exclude<ResultadoNome, 'ok'>, string> = {
  longo: `O nome da sala tem até ${NOME_DE_SALA_MAX} caracteres.`,
  ofensivo: 'Escolha outro nome para a sala.',
};
